import i18n, { Resource } from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { I18N_DEBUG_MODE } from "../config";
import { resources } from "./resources";

const getTranslationNs = (obj: Resource) => Object.keys(obj[Object.keys(obj)[0]]);

const translationNs = getTranslationNs(resources);
export type TranslationNs = keyof (typeof resources)["en"];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: ["en"],
    ns: translationNs,
    resources,
    interpolation: {
      escapeValue: true
    },
    returnNull: false,
    react: {
      useSuspense: false,
      transEmptyNodeValue: "",
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ["br", "strong", "i"]
    },
    detection: {
      order: ["path", "navigator", "querystring", "cookie", "localStorage", "sessionStorage", "htmlTag", "subdomain"]
    },
    debug: I18N_DEBUG_MODE
  });

export default i18n;
